import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { fetchUserDetails } from '../../DatabaseApis/DBQuery';
import { getCookie } from '../../utils/cookieUtils';
import { isSuperAdminEmail } from '../../utils/superAdminUtils';

const ProtectedRoute = ({ element, roles }) => {
  const userData = getCookie("userData");
  const [userRole, setUserRole] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => { 
    const loadUserDetails = async () => {
      try {
        const token = userData?.token;
  
        if (!token) {
          console.error("Token not found in cookies");
          setLoading(false);
          return;
        }

        // Detect superadmin emails from env
        const isSuperAdmin = isSuperAdminEmail(userData?.email);

        // If superadmin, skip fetchUserDetails and set role directly
        if (isSuperAdmin) {
          console.log("Superadmin detected, setting role directly");
          setUserRole('superadmin');
          setLoading(false);
          return;
        }
  
        const userDetails = await fetchUserDetails(token);
        console.log("User details from ProtectedRoute:", userDetails);
  
        if (userDetails) {
          setUserRole(userDetails.role);
          console.log("User role set to:", userDetails.role);
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      } finally {
        setLoading(false);
      }
    };
  
    loadUserDetails();
  }, [userData]);

  // Early return for unauthenticated users
  if (!userData || !userData.token) {
    console.log("No user data or token found in cookies");
    return <Navigate to="/" />;
  }

  // Show a loading indicator while fetching user details
  if (loading) {
    return <div>Loading...</div>;
  }

  // Normalize roles for comparison
  let normalizedUserRole = (userRole || '').toLowerCase();
  const isSuperAdmin = isSuperAdminEmail(userData?.email);
  if (isSuperAdmin) {
    normalizedUserRole = 'superadmin';
  }
  const normalizedRoles = (roles || []).map(r => r.toLowerCase());
  console.log("Current user role (normalized):", normalizedUserRole);
  console.log("Required roles (normalized):", normalizedRoles);
  console.log("Is SuperAdmin:", isSuperAdmin);

  // Restrict access based on roles
  if (roles) {
    // Treat tenant admin as admin
    const userRoleForComparison = normalizedUserRole.replace('tenant ', '');
    const hasRequiredRole = normalizedRoles.includes(userRoleForComparison);
    const superadminCanAccess = isSuperAdmin && normalizedRoles.some((role) =>
      ['user', 'admin', 'superadmin'].includes(role)
    );
    
    if (!hasRequiredRole && !superadminCanAccess) {
      console.log("Access denied - role not authorized");
      return <Navigate to="/" />;
    }
  }

  // Render the protected element
  return element;
}

export default ProtectedRoute;
